module.exports = __webpack_public_path__ + "img/translationeditor_22.ba6b45f1.jpg";